import { FC } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import lang from '../../../../lib/language';
import { RootState } from '../../../../lib/store';
import { FundamentalCall } from '../../../../lib/store/fundamental/types';
import MarketStateCache from '../../../../lib/store-util/MarketStateCache';
import { isCallStatusReady } from '../../../../lib/util/error-handling/StatusByCallHelpers';
import { isMarketRegularHours } from '../../../../lib/util/MarketDataHelpers';

import { Preloader } from '../../../../components';
import HotGappersList from '../HotGappersList/HotGappersList';
import MarketRegularHoursTimer from '../MarketRegularHoursTimer/MarketRegularHoursTimer';

type ContentByMarketStatusProps = { isGapUpSelected: boolean }
type Props = ContentByMarketStatusProps & ReduxProps;

const ContentByMarketStatus: FC<Props> = (props: Props): JSX.Element => {
  const { marketState } = MarketStateCache.use();
  const isMarketHours = isMarketRegularHours(marketState);
  const { isGappersReady, isGapUpSelected, gappersData } = props;

  return (
    <>
      <MarketRegularHoursTimer />
      {isMarketHours
        && (!isGappersReady ? (
          <Preloader />
        ) : (
          <HotGappersList
            isGapUpSelected={isGapUpSelected}
            title={isGapUpSelected ? lang.gappersTitleGapUp() : lang.gappersTitleGapDown()}
            data={gappersData}
          />
        ))}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isGappersReady: isCallStatusReady(FundamentalCall.getGappers, state.fundamental.statusByCall),
  gappersData: state.fundamental.gappersData,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ContentByMarketStatus);
